import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import React, { useContext } from 'react';
import { Divider, Typography } from '@applyboard/ui-components';
import { connect } from 'react-redux';
import InitialPropsContext from "../../../components/InitialPropsContext";
import CustomFields from "../../../components/CustomFields";
import EmailCreator from "../../../components/EmailCreator";
import { _CardWrapperDiv } from "../../../components/core/card/cardStyles";
import IntakeDealineDetails from "./IntakeDealineDetails";
import { dividerStyle } from "./styles";
import { applicationCustomFieldsEnhancer } from "../enhancer";
import componentErrorBoundary from "../../../components/enhancers/componentErrorBoundary";
import { useInitialProps } from "../../../hooks/useInitialProps";
import { WaitForApplicationData } from "../ApplicationDataLoader";
var CustomFieldsTab = function CustomFieldsTab(_ref) {
  var applicationId = _ref.applicationId,
    studentId = _ref.studentId,
    savedProgramIntakeStartDate = _ref.savedProgramIntakeStartDate;
  var _useInitialProps = useInitialProps(),
    permissions = _useInitialProps.permissions;
  var hasPermission = function hasPermission(name) {
    return permissions ? permissions[name] : false;
  };
  var _useContext = useContext(InitialPropsContext),
    programIntakeSupplementalInformations = _useContext.program_intake_supplemental_informations; // eslint-disable-line @typescript-eslint/no-explicit-any

  var programIntakeSupplementalInformation = null;
  if (savedProgramIntakeStartDate && programIntakeSupplementalInformations && programIntakeSupplementalInformations.length > 0) {
    programIntakeSupplementalInformation = programIntakeSupplementalInformations.find(function (fProgramIntakeSupplementalInformation) {
      return fProgramIntakeSupplementalInformation.start_date === savedProgramIntakeStartDate;
    }) || null;
  }
  return /*#__PURE__*/React.createElement(_CardWrapperDiv, {
    setRadius: "7px",
    role: "region",
    "aria-label": "Custom Fields"
  }, applicationId ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    gutterBottom: true
  }, "Custom Fields"), /*#__PURE__*/React.createElement(EmailCreator, {
    studentId: studentId,
    hasPermission: hasPermission
  }), /*#__PURE__*/React.createElement(CustomFields, {
    applicationId: applicationId,
    hasPermission: hasPermission,
    inContentSection: true,
    studentId: studentId
  }), programIntakeSupplementalInformation && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, {
    variant: "middle",
    style: dividerStyle
  }), /*#__PURE__*/React.createElement(IntakeDealineDetails, {
    programIntakeSupplementalInformation: {
      refundDeadline: programIntakeSupplementalInformation.refund_deadline,
      refundDeadlineNote: programIntakeSupplementalInformation.refund_deadline_note,
      visaRefusalRefundDeadline: programIntakeSupplementalInformation.visa_refusal_refund_deadline,
      deferralDeadline: programIntakeSupplementalInformation.deferral_deadline,
      deferralDeadlineNote: programIntakeSupplementalInformation.deferral_deadline_note,
      visaRefusalDeferralDeadline: programIntakeSupplementalInformation.visa_refusal_deferral_deadline
    }
  }))) : null);
};
var mapStateToProps = function mapStateToProps(state) {
  var _state$application;
  return {
    savedProgramIntakeStartDate: (state === null || state === void 0 ? void 0 : (_state$application = state.application) === null || _state$application === void 0 ? void 0 : _state$application.savedProgramIntakeStartDate) || null
  };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var CustomFieldsTabComponent = applicationCustomFieldsEnhancer(componentErrorBoundary(connect(mapStateToProps)(CustomFieldsTab)));
export default function LegacyCustomFieldsTab() {
  return /*#__PURE__*/React.createElement(WaitForApplicationData, null, /*#__PURE__*/React.createElement(CustomFieldsTabComponent, null));
}